import React, { useState, useEffect } from 'react';
import './EmbankmentRSA.css';
import '../../../../Tabs/ToggleSwitch.css';

const CONSTANT_PAYLOAD = {
  max_ec2_instances: 1,
  slopes_params: {
    section_height: 5,
    min_distance_between_points: 1.5,
    section_bins_size: 1.5,
    min_bin_points_precent: 0.05,
    max_x_to_calc: 40,
    units: 'feet',
    add_slope_points_to_section_image: true,
    DL_Model: false,
    two_way_analysis: false,
    slopes_warrent_categories: [
      [5, 'inf', -0.5],
      [5, 6,   -0.4667],
      [6, 7,   -0.4333],
      [7, 8,   -0.4],
      [8, 9,   -0.3667],
      [9, 10,  -0.333],
      [10,'inf', -0.333],
    ],
  }
};

export default function EmbankmentTabRSA({ initialData = {}, onSave, lidarType }) {
  const [db, setDb] = useState(initialData.db || '');
  const [collection, setCollection] = useState(initialData.collection || '');

  // Whenever db, collection or lidarType changes, auto-build & lift the payload
  useEffect(() => {
    if (!db || !collection) return;
    const payload = {
      db,
      collection,
      max_ec2_instances: CONSTANT_PAYLOAD.max_ec2_instances,
      slopes_params: {
        ...CONSTANT_PAYLOAD.slopes_params,
        aerial_data: lidarType === 'aerial',
        two_way_analysis: lidarType === 'aerial',
      }
    };
    console.log(
      'Auto-saving embankment payload:', 
      'lidarType=', lidarType, 
      '=> aerial_data=', lidarType === 'aerial'
    );
    onSave(payload);
  }, [db, collection, lidarType, onSave]);

  // You can still have a Save button if you want manual confirmation:
  const handleSaveClick = () => {
    if (!db || !collection) {
      alert('Please fill both DB and Collection.');
    } else {
      // The effect above has already run; nothing more to do
      alert('Embankment payload updated!');
    }
  };

  return (
    <div className="embankment-form-page">
      <h2>Enter Embankment Details</h2>

      <div className="form-group">
        <label>Mongo Database:</label>
        <input
          type="text"
          value={db}
          onChange={e => setDb(e.target.value)}
          required
        />
      </div>

      <div className="form-group">
        <label>Mongo Collection:</label>
        <input
          type="text"
          value={collection}
          onChange={e => setCollection(e.target.value)}
          required
        />
      </div>

      <div style={{ marginTop: '1rem' }}>
        <button
          type="button"
          onClick={handleSaveClick}
        >
          Save
        </button>
      </div>
    </div>
  );
}
